import type { ReactNode } from 'react'
import Box, { type BoxProps } from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { mergeSx } from 'lib/helpers/mergeSx/mergeSx'
import { ModalContentPaddingX } from 'settle-ui/components/Modal/components/ModalContent/ModalContent'

export interface ModalFooterProps extends Omit<BoxProps, 'title'> {
  leftButtons?: ReactNode
  rightButtons?: ReactNode
}

export const ModalFooter: Settle.FC<ModalFooterProps> = ({ leftButtons, rightButtons, children, sx, ...props }) => (
  <Box data-testid="modal-footer" {...props} sx={mergeSx({ paddingX: ModalContentPaddingX, paddingY: 1.5 }, sx)}>
    {children}
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 1.5 },
      }}
    >
      {leftButtons && (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          {leftButtons}
        </Stack>
      )}
      {rightButtons && (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.5}
          sx={{
            ml: { sm: 'auto' },
            alignItems: { sm: 'center' },
            textAlign: { xs: 'center', sm: 'initial' },
          }}
        >
          {rightButtons}
        </Stack>
      )}
    </Box>
  </Box>
)
